<script setup lang="ts">
import UIButton from '@/shared/ui/Button/Button.vue';

const { t } = useI18n();
const localePath = useLocalePath();
</script>

<template>
  <div class="for-business">
    <div class="for-business__item _image">
      <NuxtImg
        src="/images/about/business.webp"
        :alt="t('forBusinessAbout')"
        class="for-business__image"
      />
    </div>
    <div class="for-business__item _text">
      <div class="for-business__text">
        <div class="for-business__title">
          {{ t('forBusiness') }}
        </div>
        <div class="for-business__description">
          {{ t('forBusinessAboutDescription') }}
        </div>
      </div>
      <div class="for-business__button-wrapper">
        <UIButton :text="t('more')" :to="localePath('for-business')" />
      </div>
    </div>
  </div>
</template>

<style lang="less">
.for-business {
  display: flex;
  gap: 48px;
  align-items: center;
  background-color: @color-athens-gray-dark;
  padding: @size-x8;
  border-radius: @size-x6;

  &__item {
    &._text {
      .flex-column(@size-x6);

      max-width: 703px;
    }
  }

  &__text {
    .flex-column(@size-x4);
  }

  &__title {
    .h2();

    text-transform: uppercase;
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
    color: @color-dove-gray-secondary;
  }

  &__image {
    display: block;
    width: 540px;
    height: 274px;
    border-radius: @size-x6;
    object-fit: cover;
  }

  &__button-wrapper {
    max-width: 162px;
  }

  @media @1024 {
    flex-direction: column;
    gap: @size-x8;
    padding: @size-x6 @size-x4;

    &__item {
      width: 100%;

      &._image {
        order: 2;
      }

      &._text {
        order: 1;
        gap: @size-x4;
      }
    }

    &__image {
      width: 100%;
      height: 160px;
    }

    &__text {
      gap: @size-x3;
    }

    &__description {
      font-size: 15px;
      line-height: 130%;
    }
  }
}
</style>
